import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/use-toast';

export const useRealtimeNotifications = () => {
  useEffect(() => {
    const channel = supabase
      .channel('admin-notifications')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'clientes'
        },
        (payload) => {
          toast({
            title: "Nuevo cliente registrado",
            description: `${payload.new.nombre} se ha registrado`,
          });
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'mandatos_sepa'
        },
        (payload) => {
          toast({
            title: "Nuevo mandato SEPA",
            description: `Mandato firmado por ${payload.new.nombre_titular}`,
          });
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'checklists_seguridad'
        },
        (payload) => {
          toast({
            title: "Nuevo checklist creado",
            description: "Un técnico ha completado un checklist",
          });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);
};